import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Styles from './Buttons.module.scss';

export const GhostButton = ({
  type = 'button',
  size,
  children,
  onClick,
  disabled,
  to,
  title = '',
  iconLeft,
  large,
  className,
  danger
}) => {
  const classNames = classnames(Styles['ghost-button'], {
    [Styles['with-icon']]: iconLeft,
    [Styles['large']]: large || size === 'large',
    [Styles['small']]: size === 'small',
    [Styles.danger]: danger,
    [className]: className
  }, 'stop-drag');

  if (to && !disabled) {
    return (
      <Link to={to} className={classNames} title={title}>
        {iconLeft ? iconLeft : null}
        {children}
      </Link>
    );
  }
  return (
    <button
      disabled={disabled}
      className={classNames}
      type={type}
      onClick={onClick}
    >
      {iconLeft ? iconLeft : null}
      {children}
    </button>
  );
};

GhostButton.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  iconLeft: PropTypes.element,
  size: PropTypes.oneOf(['small', 'large', '']),
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  onClick: PropTypes.func,
  title: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export const RaisedButton = ({
  type,
  children,
  onClick,
  href,
  title = '',
  to,
  iconLeft,
  disabled = false,
  large,
  size,
  className
}) => {
  const classNames = classnames(Styles['raised-button'], {
    [Styles['with-icon']]: iconLeft,
    [Styles['large']]: large || size === 'large',
    [Styles['small']]: size === 'small',
    [className]: className
  }, 'stop-drag');

  if (to && !disabled) {
    return (
      <Link to={to} className={classNames} title={title} onClick={onClick}>
        {iconLeft ? iconLeft : null}
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classNames} title={title}>
        {iconLeft ? iconLeft : null}
        {children}
      </a>
    );
  }
  return (
    <button
      disabled={disabled}
      className={classNames}
      type={type}
      onClick={onClick}
    >
      {iconLeft ? iconLeft : null}
      {children}
    </button>
  );
};

RaisedButton.propTypes = {
  title: PropTypes.string,
  large: PropTypes.bool,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  type: PropTypes.string,
  iconLeft: PropTypes.element,
  size: PropTypes.oneOf(['small', 'large', '']),
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string,
    PropTypes.number
  ]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onClick: PropTypes.func,
  className: PropTypes.string
};

export const InactiveButton = ({ type, children, onClick }) => {
  return (
    <button className={Styles['inactive-button']} type={type} onClick={onClick}>
      {children}
    </button>
  );
};

InactiveButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  onClick: PropTypes.func
};

export const SquareButton = ({ size, type, children, onClick }) => {
  return (
    <button
      className={classnames([
        Styles['square-button'],
        { [Styles[size]]: !!size }
      ])}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

SquareButton.propTypes = {
  size: PropTypes.oneOf(['small', '']),
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  onClick: PropTypes.func
};

export const SquareGhostButton = ({ size, type, children, onClick }) => {
  return (
    <button
      className={classnames([
        Styles['square-ghost-button'],
        { [Styles[size]]: !!size }
      ])}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

SquareGhostButton.propTypes = {
  size: PropTypes.oneOf(['small', '']),
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ]),
  onClick: PropTypes.func
};
